import React from "react";
import { DatePicker } from "antd";
import ScheduleFieldWrapper from "./ScheduleFieldWrapper";
import calendarIcon from "../../../../assets/svg/calendarIcon.svg"

const ScheduleDatePicker = ({
  label = "Date",
  required = false,
  value,
  onChange,
  disabled = false,
  placeholder = "Select date",
}) => {
  return (
    <ScheduleFieldWrapper label={label} required={required}>
      <DatePicker
        disabled={disabled}
        value={value}
        onChange={onChange}
        format="YYYY-MM-DD"
        superPrevIcon={<></>}
        superNextIcon={<></>}
        suffixIcon={<></>}
        style={{ width: "100%", border: "none", padding: 0, margin: 0, hover: "none", boxShadow: "none", display: "flex", justifyContent: "space-between" }}
        placeholder={placeholder}
      />
      <img src={calendarIcon} alt="calendar-icon" className="h-6 w-6 cursor-pointer mt-[-13px]" />
    </ScheduleFieldWrapper>
  );
};

export default ScheduleDatePicker;
